/* eslint-disable max-classes-per-file */
import { ICommentRequest } from '../model/comment.model';

export class LoadComments {
  static readonly type = '[Comments] Load Comments';
  constructor(
    public entityType: number,
    public entityId: string,
    public isInPopup: boolean
  ) {}
}

export class AddComment {
  static readonly type = '[Comments] Add Comment';
  constructor(
    public entityType: number,
    public comment: ICommentRequest,
    public isInPopup?: boolean
  ) {}
}

export class UpdateComment {
  static readonly type = '[Comments] Update Comment';
  constructor(
    public entityType: number,
    public id: string,
    public comment: ICommentRequest,
    public isInPopup?: boolean
  ) {}
}

export class DeleteComment {
  static readonly type = '[Comments] Delete Comment';
  constructor(
    public entityType: number,
    public entityId: string,
    public id: string,
    public isInPopup?: boolean
  ) {}
}

export class ClearComments {
  static readonly type = '[Comments] Clear Comments';
}
